import hasOnlyNumbers from '../function/hasOnlyNumbers';

export const isValidAccountNumber = (value: string) =>
  hasOnlyNumbers(value);
